import React from "react";
import GUI from "../GUI";

export default function Loading(props:React.ComponentPropsWithoutRef<"div">){
    const {className,...divProps} = props
    return <div className={GUI.joinClass("loading", props.className)} {...divProps}><span/><span/><span/></div>
}